<template>
	<div class="d-flex flex-row mt-3">
		<div class="mr-4">
				<avatar :user="post.user ? post.user : null"/>
			</div>
		<div class="post-comment comment-success w-100">
			
			<div class="flex-grow-1">
				<div class="post-comment-content">
					<div class="d-flex flex-row justify-content-between">
						<div v-if="post.user">
							<div class="bold">{{ post.user.name || post.user.email }}</div>
							<div class="text-muted font-12">User description</div>
						</div>
					</div>
					<div class="mt-2">
						<multicontent v-if="problem.solution" :content="problem.solution" class="mt-2"/>
						<div v-else class="mt-2">{{ this.$vuetify.lang.t('$vuetify.views.wall.problem.noSolutionDescription') }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Avatar from "@/components/Avatar"
import Multicontent from '@/components/items/Multicontent'
export default {
	props: {
		post: {
			type: Object,
			required: true,
		}
	},
	components: {
		Multicontent,
		Avatar
	},
	computed: {
		problem() {
			return this.post.postable;
		}
	}
}
</script>